import { adjustFormat, toUTCFromTz } from 'util/DateTime';

export const toInternalTime = (date: string, userTimezone) => adjustFormat(toUTCFromTz(date, userTimezone), 'internal');

export const getInstantArchivingUriParams = (values: { from: string, to: string, full_delete?: boolean, wipe_restores?: boolean }, userTimezone: string) => {
  const from = values.from ? toInternalTime(values.from, userTimezone) : '';
  const to = values.to ? toInternalTime(values.to, userTimezone) : '';

  const fullDelete = !!values.full_delete;
  const wipeRestores = !!values.wipe_restores;

  const timeRangeUriParams = from !== '' || to !== '' ? `from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}` : '';

  const fullDeleteUriParams = fullDelete ? `full_delete=${fullDelete}&wipe_restores=${wipeRestores}` : '';

  if (fullDelete) {
    if (timeRangeUriParams.length > 0) {
      return `${timeRangeUriParams}&${fullDeleteUriParams}`;
    }

    return fullDeleteUriParams;
  }

  return timeRangeUriParams;
};
